
<div class="gallery-menu" *ngIf="photos && photos.length > 0">
    <div class="row">
        <div class="col-md-6">
            <div class="bulk-actions-container">

                <div class="dropdown dropdown-select">
                    <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-2x" [ngClass]="getSelectedPhotoCount() > 0 ? 'fa-regular fa-check-square' : 'fa-regular fa-square'"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" (click)="toggleAllPhotoSelection(true)">
                            Select all
                        </a>
                        <a class="dropdown-item" (click)="toggleAllPhotoSelection(false)">
                            Unselect all
                        </a>
                        <hr />
                        <ng-container *ngFor="let year of photoYears">
                            <a class="dropdown-item" (click)="toggleAllPhotoSelection(true, year)">
                                Select all {{sortBy == 'takenDate'? 'taken':'uploaded' }} in {{year == null || year == 'null' ? 'unknown year' : year}}
                            </a>
                        </ng-container>

                    </div>
                </div>

                <span class="font-light selected-count">{{getSelectedPhotoCount()}} selected</span>
                    <div id="choose-action" class="dropdown dropdown-bulk-actions" placement="top">
                        <button class="btn dropdown-toggle" [disabled]="getSelectedPhotoCount() == 0" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span>Choose action</span>
                        </button>
                        <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" (click)="onBulkAssignComponent()">
                                <i class="fa fa-fw fa-link padding-right-10" aria-hidden="true"></i> Assign {{ 'component' | terminology | async }}
                            </a>
                            <a class="dropdown-item" (click)="onBulkUpdateReportSettings()">
                                <i class="fa fa-fw fa-link padding-right-10" aria-hidden="true"></i> Update report settings
                            </a>

                            <a class="dropdown-item" (click)="onBulkDownload()">
                                <i class="fa fa-fw fa-download padding-right-10" aria-hidden="true"></i> Download
                            </a>
                            <a *spHasRole="['Admin', 'Manager', 'PortfolioAdmin']" class="dropdown-item" (click)="onBulkDelete()">
                                <i class="fa fa-fw fa-trash-can padding-right-10" aria-hidden="true"></i> Delete
                            </a>
                        </div>
                    </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="text-end">
                <div class="sort-by">
                    <div class="dropdown">
                        <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="sort-label">Sort by:</span> {{sortByName}}
                        </button>
                        <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" (click)="changeSortOrder('uploadDate', true)"><strong>Date Uploaded </strong> - Newest to Oldest</a>
                            <a class="dropdown-item" (click)="changeSortOrder('uploadDate', false)"><strong>Date Uploaded </strong> - Oldest to Newest</a>
                            <a class="dropdown-item" (click)="changeSortOrder('takenDate', true)"><strong>Date Taken </strong> - Newest to Oldest</a>
                            <a class="dropdown-item" (click)="changeSortOrder('takenDate', false)"><strong>Date Taken </strong> - Oldest to Newest</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-end text-muted font-light">Displaying  <strong>{{photos.length}}</strong> photos</div>
        </div>
    </div>

</div>

<div>
    <ng-container *ngFor="let year of photoYears">
        <div class="year-separator" title="Photos uploaded in {{year}}">
            <span *ngIf="sortBy == 'uploadDate'">Photos uploaded in {{year}}</span>
            <span *ngIf="sortBy == 'takenDate'">Photos taken in {{year == null || year == 'null' ? 'unknown year' : year}}</span>
        </div>
        <div class="photo-gallery-container">
            <ng-container *ngFor="let photo of photosGroupedByYear[year]">
                <div class="photo-item scroll-margin" [class.selected]="isPhotoSelected(photo)" [class.viewing]="photo.propertyPhotoId == photoToView?.propertyPhotoId" [id]="photo.propertyPhotoId">
                    <div class="photo">
                        <img [src]="photo.largeFileUrl || ''" />

                        <div class="photo-detail">                            
                            
                            <!-- This eventually could have MULTIPLE component names.  Just use the 1st for now if exists -->
                            <div class="name" [class.no-component]="photo.propertyComponents?.length === 0">
                                {{photo.propertyComponents?.length > 0 ? photo.propertyComponents[0].name : ('No assigned ' + (('component' | terminology | async) || 'component'))}}
                            </div>
                            
                            <div class="description">{{photo.description | truncate : 100}}</div>
                        </div>
                    </div>
                    <div class="hover-overlay" (click)="onHoverOverlayClicked(photo, $event)">
                        <div>
                            <div class="select-photo pull-left" (click)="togglePhotoSelection(photo, $event)" [class.selected]="isPhotoSelected(photo)">
                                <span class="fa-stack">
                                    <i class="fa fa-circle fa-stack-2x"></i>
                                    <i class="fa fa-check fa-stack-1x"></i>
                                </span>
                            </div>
                            <div class="view-photo pull-right" (click)="onViewPhoto(photo, $event)" [hidden]="getSelectedPhotoCount() == 0">
                                <i class="fa fa-eye"></i>
                            </div>
                        </div>

                    </div>

                </div>
            </ng-container>
        </div>
    </ng-container>
</div>

<sp-modal title="REMOVE PHOTO" (confirm)="onBulkDeleteConfirm()" confirmButtonText="Remove" isWarning="true" #bulkDeletePhotos>
    Do you want to remove the <strong>{{getSelectedPhotoCount()}} selected photos</strong> from your photo library?
</sp-modal>

<sp-bulk-assign-component-modal
    #bulkAssignPhotos
    [propertyId]="propertyId"
    [fiscalYear]="fiscalYear"
    [selectedPhotoCount]="getSelectedPhotoCount()"
    (onConfirm)="onBulkAssignComponentConfirm($event)">
</sp-bulk-assign-component-modal>

<sp-modal title="UPDATE PHOTO REPORT SETTINGS" (confirm)="onBulkReportSettingsConfirm()" confirmButtonText="Update" #bulkUpdateReportSettings>
    Indicate if the selected photos should be included in the Photos Report

    <div class="margin-top-20">
        <input name="bulkIncludePhotosInReport" id="bulkIncludePhotosInReport" type="checkbox" [checked]="bulkIncludePhotosInReport" (click)="toggleBulkIncludePhotosInReport()" />
         <label for="bulkIncludePhotosInReport">Include in Photos report</label>
    </div>

    <div class="margin-top-20 text-muted font-italic">The selected photos <strong>{{bulkIncludePhotosInReport ? 'will be included in' : 'will be excluded from'}}</strong> the Photos report.</div>

</sp-modal>

<dx-tooltip target="#choose-action" [wrapperAttr]="{ class: 'choose-action-tooltip' }" showEvent="mouseenter"
    hideEvent="mouseleave" position="top" (onShowing)="onPopupShowing($event)">
    <div *dxTemplate="let data = data; of: 'content'">
        <div>
            Select at least one photo to activate options
        </div>
    </div>
</dx-tooltip>
